import { __assign } from "tslib";
import React from 'react';
import classnames from 'classnames';
import ddt from '@wix/da-ddt';
import { getInfoToDisplayImageDeviation } from './_helpers';
import Unknown from '../Unknown';
import Flag from '@wix/da-react-context/pkg/flags/Flag';
import { useLazyLoading } from '../../../LazyLoadingImage/useLazyLoading';
import { isValidFileSrc } from '../../_helpers';
import s from './Image.scss';
/**
 * If you are changing any fundamentals here please remember to also
 * consider the DaEditorWrappers image views, they use this to generate
 * HTML and react version of editor text.
 */
var ImageDumbView = function (props) {
    var deviation = props.deviation, className = props.className, propsWidth = props.width, propsHeight = props.height, _a = props.allowPreviewUsage, allowPreviewUsage = _a === void 0 ? true : _a, _b = props.useBackgroundColor, useBackgroundColor = _b === void 0 ? true : _b, greenLikeCrop = props.greenLikeCrop, noCropping = props.noCropping, extraWrapStyles = props.extraWrapStyles, ariaHidden = props["aria-hidden"];
    var _c = useLazyLoading(true), ref = _c.ref, inView = _c.inView, enableLazyLoading = _c.enableLazyLoading, supportsNativeLazy = _c.supportsNativeLazy;
    if (!propsWidth && !propsHeight) {
        // no use-cases for responsive image views
        ddt.warn('deviationviews', 'Deviation image is not rendered because of missing Width and Height properties');
        return null;
    }
    var info = getInfoToDisplayImageDeviation({
        deviation: deviation,
        height: propsHeight,
        width: propsWidth,
        allowPreviewUsage: allowPreviewUsage,
        greenLikeCrop: greenLikeCrop,
        noCropping: noCropping,
    });
    if (!info || !info.pickedImage || !isValidFileSrc(info.pickedImage.src)) {
        ddt.warn('deviationviews', 'Could not find a suitable image file to render deviation image', info);
        return React.createElement(Unknown, __assign({}, props));
    }
    var height = info.height, width = info.width, imgStyles = info.imgStyles, pickedImage = info.pickedImage;
    ddt.log('deviationviews.thumbtype', "Used ".concat(pickedImage.type));
    var imageProps = {
        src: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=',
        // 1px transparent png
    };
    var wrapStyles = __assign(__assign({}, extraWrapStyles), { width: width, height: height });
    var imageStyles = __assign({ width: width, height: height }, imgStyles);
    // Native lazy loading is simple
    if (enableLazyLoading && supportsNativeLazy) {
        imageProps.loading = 'lazy';
        imageProps.src = pickedImage.src;
    }
    // Intersection Observer lazy loading
    if (enableLazyLoading && !supportsNativeLazy) {
        if (inView) {
            imageProps.src = pickedImage.src;
        }
    }
    // Standard non lazy loaded
    if (!enableLazyLoading) {
        imageProps.src = pickedImage.src;
    }
    if (pickedImage.srcSet) {
        imageProps.srcSet = pickedImage.srcSet;
    }
    return (React.createElement("div", { ref: enableLazyLoading && !supportsNativeLazy ? ref : undefined, className: classnames(s['wrapper'], className, !useBackgroundColor && s['no-background']), style: wrapStyles, "aria-hidden": ariaHidden },
        renderDebug(info.pickedImage, propsWidth, propsHeight, enableLazyLoading),
        React.createElement("img", __assign({ alt: deviation.title, style: imageStyles }, imageProps)),
        enableLazyLoading && !supportsNativeLazy && (React.createElement("noscript", null,
            React.createElement("img", { alt: deviation.title, src: pickedImage.src, srcSet: pickedImage.srcSet, style: imageStyles })))));
};
ImageDumbView.displayName = 'ImageDumbView';
function renderDebug(pickedImage, propsWidth, propsHeight, isLazy) {
    return (React.createElement(Flag, { condition: "thumbdebug" },
        React.createElement("div", { className: s['thumb-debug'] },
            isLazy && 'lazy/',
            pickedImage.type,
            "/",
            pickedImage.src.replace(/\?.*/, '').split('.').pop(),
            "/",
            pickedImage.transparency === true ? 'true' : 'false',
            "/",
            React.createElement("abbr", { title: "imageDims" },
                pickedImage.width,
                "x",
                pickedImage.height),
            "/",
            React.createElement("abbr", { title: "blockDims" },
                propsWidth,
                "x",
                propsHeight))));
}
export default ImageDumbView;
//# sourceMappingURL=Image.js.map